import { MainMenuItem } from './layout/main-menu.service';
import { environment } from '../environments/environment';
import { routerSegments } from '@consts/routes';
import { PermissionModel } from '@models/permission.model';

const developerRole =
  environment.env === 'DEV' || environment.env === 'localNoKube' || environment.env === 'dev-hosted' ? ['user'] : ['admin'];

export const mainMenuItems: MainMenuItem[] = [
  {
    displayName: 'MAIN_MENU.DEVICES',
    path: routerSegments.locationV2,
    roles: ['user'],
    class: 'ui-icon-camera-sidebar',
    permissions: [],
    videoUrl: 'https://www.youtube.com/watch?v=k63a2zYw2Hw',
  },
  {
    displayName: 'MAIN_MENU.SEARCH',
    path: `${routerSegments.search}`,
    roles: ['user'],
    disabled: false,
    class: 'ui-icon-search-sidebar',
    permissions: [PermissionModel.Permissions.SearchView],
    videoUrl: 'https://www.youtube.com/watch?v=iyndNPWjQJc',
  },
  {
    displayName: 'MAIN_MENU.ALERTS',
    path: routerSegments.alertsV2,
    roles: ['user'],
    disabled: false,
    class: 'ui-icon-notifications-sidebar',
    permissions: [
      PermissionModel.Permissions.AlertMonitoring,
      PermissionModel.Permissions.CallCenter,
      PermissionModel.Permissions.EventCreate,
      PermissionModel.Permissions.EventRead,
      PermissionModel.Permissions.AlertGroups,
    ],
    videoUrl: 'https://www.youtube.com/watch?v=dEtuHMh-WHk',
  },
  {
    displayName: 'MAIN_MENU.DASHBOARDS',
    path: `${routerSegments.dashboards}`,
    roles: ['user'],
    disabled: false,
    class: 'ui-icon-dashboard-sidebar',
    permissions: [PermissionModel.Permissions.DashboardView],
  },
  {
    displayName: 'MAIN_MENU.WALLS',
    path: routerSegments.wallV2,
    roles: ['user'],
    disabled: false,
    class: 'ui-icon-wall-sidebar',
    permissions: [PermissionModel.Permissions.WallRead],
    videoUrl: 'https://www.youtube.com/watch?v=MkGH-eHrt60',
  },
  // {
  //   displayName: 'MAIN_MENU.ALARMS_MANAGER',
  //   path: routerSegments.alarmsManager,
  //   roles: developerRole,
  //   disabled: false,
  //   class: 'ui-icon-notifications',
  //   permissions: [],
  // },
  // {
  //   displayName: 'Alerts View',
  //   icon: 'list',
  //   path: routerSegments.alertEventsMonitoring,
  //   roles: ['user'],
  //   disabled: false,
  // },
  {
    displayName: 'MAIN_MENU.ARCHIVES',
    path: routerSegments.archive,
    roles: ['user'],
    disabled: false,
    class: 'ui-icon-archive-sidebar',
    permissions: [PermissionModel.Permissions.ArchiveRead],
  },
  {
    displayName: 'MAIN_MENU.REPORTS',
    path: routerSegments.reports,
    roles: ['user'],
    disabled: false,
    svg: 'menu-table-new-sidebar',
    permissions: [PermissionModel.Permissions.ReportView],
  },
  {
    displayName: 'MAIN_MENU.CASES',
    path: routerSegments.cases,
    roles: ['user'],
    disabled: false,
    class: 'ui-icon-menu-folder-sidebar',
    permissions: [PermissionModel.Permissions.CaseManage],
    videoUrl: 'https://www.youtube.com/watch?v=RWVVKuz0tCE',
  },
  // {
  //   displayName: 'MAIN_MENU.PARTNER_PORTAL',
  //   path: routerSegments.partnerPortal,
  //   roles: ['user'],
  //   disabled: false,
  //   class: 'ui-icon-dashboards',
  //   permissions: [],
  // },
  // {
  //   displayName: 'Settings',
  //   svg: 'settings',
  //   path: `${routerSegments.settings}`,
  //   roles: ['user'],
  //   disabled: false,
  // },
  {
    displayName: 'MAIN_MENU.PRICING',
    path: `${routerSegments.pricing}`,
    roles: ['sales'],
    disabled: false,
    class: 'ui-icon-pricing-sidebar',
    permissions: [],
    orgIds: ['6826539c377e0764bd6c8499'],
  },
  {
    displayName: 'MAIN_MENU.EVENTS_MANAGER',
    path: `${routerSegments.accessControlEvents}`,
    roles: ['user'],
    disabled: false,
    class: 'ui-icon-controls-event-sidebar',
    permissions: [],
    separator: true,
  },
  {
    displayName: 'MAIN_MENU.MAP',
    path: routerSegments.map,
    roles: ['sales'],
    disabled: false,
    class: 'ui-icon-map-view',
    permissions: [],
  },
  {
    displayName: 'MAIN_MENU.WORKFLOWS',
    path: routerSegments.workflows,
    roles: ['developer'],
    disabled: false,
    class: 'ui-icon-workflow-sidebar',
    permissions: [],
  },
  {
    displayName: 'MAIN_MENU.ADVANCED_ANALYTICS_JOBS',
    path: routerSegments.advancedAnalyticsJobs,
    roles: ['user'],
    disabled: false,
    class: 'ui-icon-cash-workflow-sidebar',
    permissions: [
      PermissionModel.Permissions.AdvancedAnalyticsJobsRead,
      PermissionModel.Permissions.AdvancedAnalyticsJobsManage,
    ],
  },
  {
    displayName: 'MAIN_MENU.CHAT',
    path: routerSegments.chat,
    roles: ['user'],
    disabled: false,
    class: 'ui-icon-comment-sidebar',
    permissions: [],
  },
];
//todo consult with Edan and remove
export const developerMenuItems: MainMenuItem[] = [
  {
    displayName: 'Environment Info',
    icon: 'info',
    path: 'development/info',
    roles: developerRole,
    permissions: [],
  },
  {
    displayName: 'Heartbeats',
    icon: 'favorite',
    path: 'development/heartbeat',
    roles: developerRole,
    permissions: [],
  },
  {
    displayName: 'Analytics',
    icon: 'fingerprint',
    path: 'development/analytics',
    roles: developerRole,
    permissions: [],
  },
  {
    displayName: 'Alerts',
    icon: 'warning',
    path: 'development/alerts',
    roles: developerRole,
    permissions: [],
  },
  {
    displayName: 'Motion-Vectors',
    icon: 'directions_walk',
    path: 'development/motion-vectors',
    roles: developerRole,
    permissions: [],
  },
  {
    displayName: 'Thumbnails',
    icon: 'image',
    path: 'development/thumbnails',
    roles: developerRole,
    permissions: [],
  },
  {
    displayName: 'Logs',
    icon: 'info',
    path: 'logs',
    roles: developerRole,
    permissions: [],
  },
  {
    displayName: 'Search Canvas',
    icon: 'bug_report',
    path: 'development/search-canvas',
    roles: developerRole,
    permissions: [],
  },
  {
    displayName: 'Search Grid',
    icon: 'bug_report',
    path: 'development/search-grid',
    roles: developerRole,
    permissions: [],
  },
];
